module.exports = __webpack_public_path__ + "img/2-4.2aeb9aa7.svg";